import { type ReactNode } from 'react';
import type { TimePeriod } from '../types';

const OPTS: { value: TimePeriod; label: string }[] = [
  { value: 'today', label: 'Hoy' },
  { value: 'week', label: 'Semana' },
  { value: 'month', label: 'Mes' },
  { value: 'total', label: 'Total' },
];

const BASE =
  'rounded-md px-3 py-1 text-[11px] font-medium tracking-wide transition-all duration-200';
const ON = `${BASE} bg-white/[0.08] text-text-primary`;
const OFF = `${BASE} text-text-tertiary/50 hover:text-text-tertiary`;

type Props = { value: TimePeriod; onChange: (v: TimePeriod) => void };

export function TimePeriodSelector({ value, onChange }: Props): ReactNode {
  return (
    <div className="flex gap-0.5 rounded-lg bg-white/[0.03] p-0.5">
      {OPTS.map((o) => (
        <button
          key={o.value}
          onClick={() => onChange(o.value)}
          className={value === o.value ? ON : OFF}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
